import React, { Component } from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const aboutUs = () => (
  <section id="home-about-us">
    <div className="row">
      <div className="col">
        <div className="about-us-content">
          <img
            className="img-fluid mr-2"
            src={require("../../../assets/icons/about-icon.svg")}
            alt="About-Icon"
          />
          <span>ABOUT</span>
          <h2 className="mt-3" style={{ color: "var(--h2Color)" }}>
            What is tauchain (tau)?
          </h2>
          <div className="row pl-3 about-first-wrapper">
            <div className="col-lg-10 col-xl-9 col-md-12 col-sm my-3 p-0 pr-4">
              <p className="about-us-para" style={{ color: "var(--pColor)" }}>
                Tauchain (tau) revolutionizes discussions with a self amending
                social platform. It detects consensus and disagreemets between
                all users in real time, executing and self implementing the
                networks instructions.
              </p>
            </div>
          </div>
          <div className="row pl-3 my-3 about-second-wrapper">
            <div className="col-md-4 p-0">
              <h5
                className="why-us-heading ml-4"
                style={{
                  color: "var(--listColor)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                Use
              </h5>
              <ul className="why-us-list mt-3">
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  What can i do with Tau?
                </li>
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  How do I get Agoras?
                </li>
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  What's a wallet?
                </li>
              </ul>
            </div>
            <div className="col-md-4 p-0">
              <h5
                className="why-us-heading ml-4"
                style={{
                  color: "var(--listColor)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                Learn
              </h5>
              <ul className="why-us-list mt-3">
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  Beginner resources
                </li>
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  How Touchain works
                </li>
              </ul>
            </div>
            <div className="col-md-4 p-0">
              <h5
                className="why-us-heading ml-4"
                style={{
                  color: "var(--listColor)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                Developers
              </h5>
              <ul className="why-us-list mt-3">
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  Getting started guides
                </li>
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  Create a language
                </li>
                <li
                  className="why-us-innerlist"
                  style={{
                    color: "var(--listColor)",
                    transition: "color 0.2s ease-out, background 0.2s ease-out"
                  }}
                >
                  <img
                    className="img-fluid mr-2"
                    src={require("../../../assets/icons/arrow-colored-icon.svg")}
                    alt="Arrow-Colored"
                  />
                  Find the latest developers tools
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default aboutUs;
